import { render } from "./IdentityPage.vue?vue&type=template&id=ac78ebca&scoped=true"
import script from "./IdentityPage.vue?vue&type=script&lang=js"
export * from "./IdentityPage.vue?vue&type=script&lang=js"

import "./IdentityPage.vue?vue&type=style&index=0&id=ac78ebca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac78ebca"]])

export default __exports__